export const VALID_PERIOD_DATE_FORMATS = ["MM-YYYY", "MM-YY", "MMM-YY", "MMMM-YYYY", "M-YY", "YY-MMM", "M-YYYY"];
export const HELP_URL = "https://help.myob.com/wiki/x/-xokAw";
export const LEAVE_HELP_URL = "https://help.myob.com/wiki/x/iwOFAw";
export const WAGE_ITEM_HELP_URL = "https://help.myob.com/wiki/x/iwOFAw";
